import { loadQiDianQQServiceSDK } from './util'
export default loadQiDianQQServiceSDK
